import React, { useState, useEffect, useRef } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
} from "react-native";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";
import Workout from "../Firestore/Workout";

import { v4 as uuidv4 } from "uuid";

import { useTranslation } from "react-i18next";
import { useScreenDimensions, useDevice } from "../_layout";

const AddWorkoutView = ({ isVisible, onClose, workout, client, coach }) => {
  const { t } = useTranslation();

  const [workoutName, setWorkoutName] = useState(workout ? workout.name : "");
  const predefinedText = workout ? workout.name : t("newWorkout-string");

  const { isMobile } = useDevice();
  const nameInputRef = useRef(null);

  const titleKey = workout
    ? "changeWorkoutNameTitle-string"
    : "createWorkoutTitle-string";
  const modalTitle = workout ? t(titleKey) : t(titleKey).toUpperCase();

  useEffect(() => {
    setWorkoutName(workout ? workout.name : "");
  }, [workout]);

  useEffect(() => {
    if (!isVisible) return;
    const id = setTimeout(() => {
      nameInputRef.current?.focus?.();
    }, 100);
    return () => clearTimeout(id);
  }, [isVisible]);

  const cancel = () => {
    setWorkoutName(workout ? workout.name : "");
    onClose();
  };

  const Buttons = ({ bool }) => {
    const text = bool ? "save-string" : "cancel-string";
    const [isHovered, setIsHovered] = useState(false);
    const Save = () => {
      const newName = workoutName === "" ? predefinedText : workoutName;
      if (!workout) {
        const existingWorkouts = Array.isArray(coach?.workoutLibrary)
          ? coach.workoutLibrary
          : [];
        const newOrder =
          existingWorkouts.reduce((maxOrder, entry) => {
            const parsed = Number(entry?.order);
            return Number.isFinite(parsed) ? Math.max(maxOrder, parsed) : maxOrder;
          }, -1) + 1;

        const similarWorkouts = existingWorkouts.filter((workout) =>
          workout.name.startsWith(t("newWorkout-string"))
        );

        const newNameForLibrary =
          workoutName === ""
            ? similarWorkouts.length > 0
              ? t("newWorkoutCount-string", { count: similarWorkouts.length })
              : t("newWorkout-string")
            : workoutName;

        const newWorkout = new Workout(
          uuidv4(),
          null,
          newNameForLibrary,
          newOrder,
          0,
          false,
          null,
          [],
          coach
        );
        coach.updateCoachTransactionWorkouts(newWorkout.id);
        coach.startOrResetBatchTimer();
        coach.workoutLibrary.push(newWorkout);
      } else {
        workout.setProperty("name", newName);
      }
      setWorkoutName("");
      onClose();
    };

    return bool ? (
      <TouchableOpacity
        onPress={Save}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: Colors.bubbleColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.bubbleColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            opacity: isHovered ? 0.8 : 1,
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: Colors.whiteColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    ) : (
      <TouchableOpacity
        onPress={cancel}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: "red",
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: isHovered ? "white" : Colors.redColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={cancel}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={cancel}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View style={GlobalStyles.modalView}>
            <View
              style={{
                alignItems: "center",
                width: "100%",
              }}
            >
              <Text style={Fonts.bold18Centered}>{modalTitle}</Text>
              <TextInput
                ref={nameInputRef}
                style={[
                  GlobalStyles.textInputStyle,
                  {
                    borderColor: isHovered
                      ? "rgba(0, 0, 0, 0.5)"
                      : Colors.borderColor,
                  },
                ]}
                placeholder={t(predefinedText)}
                placeholderTextColor={Colors.grayColor}
                value={workoutName}
                onChangeText={setWorkoutName}
                maxLength={45}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              />
            </View>
            <View
              style={[
                GlobalStyles.HStack,
                {
                  justifyContent: "center",
                  width: "100%",
                  justifyContent: "space-around",
                  marginTop: 16,
                },
              ]}
            >
              <Buttons bool={false} />
              <Buttons bool={true} />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default AddWorkoutView;
